const BACKSPACE_KEY = 8;

class ExistsNumberValidateCodeCtrl {
  [x: string]: any;

  static $inject = ['MsisdnService', 'NotificationService'];

  public labelExist: boolean;

  constructor(MsisdnService, NotificationService) {
    this.code = this.focusInput = [];
    this.codeLength = [0, 1, 2, 3];
    this.pattern = /^[^\u{10000}-\u{10FFFF}]*$/u; // text without emojis

    this.msisdnService = MsisdnService;
    this.notificationService = NotificationService;
  }

  getCode() {
    return this.code.join('');
  }

  $onInit() {
    this.labelExist = false;
  }

  $onChanges(changes) {
    if (changes.currentMsisdn && this.codeForm) {
      this.code = [];
      this.codeForm.$setUntouched();
    }
  }

  isFormValid() {
    return !this.codeForm.$invalid
      && !this.labelExist;
  }

  confirm() {
    if(this.isFormValid()) {
      return this.onConfirm({code: this.getCode(), label: this.label});
    }
  }

  onChangeCode(index, event) {
    if (event.which === BACKSPACE_KEY && !this.code[index]) {
      this.focusInput[index - 1] = true;
    } else {
      this.focusInput = [];
    }
  }

  isFocus(index) {
    return this.focusInput[index] || this.code[index - 1];
  }

  validate($event) {
    const labelToCheck = $event.currentTarget.value && $event.currentTarget.value.length ? $event.currentTarget.value.trim() : '';

    if (labelToCheck) {
      this.msisdnService.isLabelExisting(labelToCheck).subscribe(
        response => {
          if (response && response.data !== null && typeof response.data === 'boolean') {
            this.labelExist = response.data;
          } else {
            this.labelExist = response.data;
            this.notificationService.open('ERROR');
          }
        }
      )
    }
    else if (labelToCheck === '') {
      this.labelExist = false;
    }
  }
}

export default {
  controller: ExistsNumberValidateCodeCtrl,
  template: require('./exists.number.validate.code.html'),
  bindings: {
    currentMsisdn: '<',
    onConfirm: '&'
  }
}
